import { HeaderContext, emptyHeaderContext } from './HeaderContext';
import { useContext, useEffect } from 'react';
import isEqual from 'lodash/isEqual';
/**
 * React hook for showing the header. Any value that whose change should trigger a
 * render should be passed as "input"
 */
export const useHeader = (initialConfig = {}, initialInputs = []) => {
    const [config, setConfig] = useContext(HeaderContext);
    const set = (newConfig) => {
        const newNewConfig = { ...config, ...newConfig };
        if (!isEqual(config, newNewConfig))
            setConfig(newNewConfig);
    };
    useEffect(() => {
        setConfig({
            ...emptyHeaderContext,
            defaults: config.defaults,
            isHeaderShown: true,
            ...config.defaults,
            ...initialConfig,
        });
        return () => setConfig({ ...emptyHeaderContext, defaults: config.defaults, isHeaderShown: false, ...config.defaults });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, initialInputs);
    return {
        showHeader: () => set({ isHeaderShown: true }),
        hideHeader: () => set({ isHeaderShown: false }),
        setHeaderItems: headerItems => set({ headerItems }),
        setSearchBar: searchBar => set({ searchBar }),
        setSecondRowItems: secondRowItems => set({ secondRowItems }),
    };
};
//# sourceMappingURL=useHeader.js.map